import _extends from '@babel/runtime/helpers/extends';
import React__default, { useCallback } from 'react';
import styled from 'styled-components';
import { M as MenuItem, B as BaseMenuItemMixin } from './MenuItem.styles-Dkrv2sP6.js';
import { K as KEYBOARD_KEYNAMES } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-CVa_vjg3-CVa_vjg3.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { B as Button } from '../../Button/Button-Cwlb3sfd.js';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1nwgizh-0"
})(["", ""], BaseMenuItemMixin);
const MenuItemButton = ({
  children,
  disabled,
  onClick,
  taktId,
  taktValue,
  ...rest
}) => {
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    switch (key) {
      case KEYBOARD_KEYNAMES.ENTER:
      case KEYBOARD_KEYNAMES.SPACE:
        onClick === null || onClick === void 0 || onClick(event);
        break;
    }
  }, [onClick]);
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('menu-item-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(MenuItem, null, /*#__PURE__*/React__default.createElement(StyledButton, _extends({
    variant: "transparent"
  }, getDataTaktAttributes(), rest, {
    type: "button",
    onClick: onClick,
    onKeyDown: onKeyDown,
    disabled: disabled
  }), children)));
};

export { MenuItemButton as M };
//# sourceMappingURL=MenuItemButton-r77zK5DX.js.map
